import { Grid2 as Grid, Button, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore, Delete } from '@mui/icons-material';
import { CustomControlledInput } from "./CustomControlledInput";
import CommonCard from './common_card';
import { TypographyBold } from '../style/typography';

const UserList = ({
    control,
    users,
    expandedUser,
    departmentList,
    roleList,
    handleEditClick,
    handleCancelEdit,
    handleDeleteClick,
    handleEditSubmit,
    openDialog,
    isDisabled
}) => {

    return (
        <Grid size={{ xs: 12 }}>
            <CommonCard
                child={
                    <Grid container spacing={3} sx={{ padding: 3 }}>
                        <Grid size={{ xs: 12 }}>
                            <TypographyBold>
                                ユーザー一覧
                            </TypographyBold>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            {users.map((user) => (
                                <Accordion
                                    key={user.uuid}
                                    expanded={expandedUser === user.uuid}
                                    onChange={() => {
                                        if (expandedUser === user.uuid) {
                                            handleCancelEdit();
                                        } else {
                                            handleEditClick(user);
                                        }
                                    }}
                                    sx={{ mb: 1 }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls={`user-content-${user.uuid}`}
                                        id={`user-header-${user.uuid}`}
                                    >
                                        <div>
                                            <Typography variant="h6" component="div">
                                                {user.name}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {user.department_name} - {user.role_name}
                                            </Typography>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {/* ここから form を開始 */}
                                        <form
                                            style={{ width: "100%" }}
                                            onSubmit={handleEditSubmit((data) => {
                                                openDialog('save', data.editUser);
                                            })}
                                        >
                                            <Grid container spacing={2} sx={{ paddingTop: 3 }}>
                                                {/* 氏名 */}
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <CustomControlledInput
                                                        name="editUser.name"
                                                        control={control}
                                                        label="氏名"
                                                        variant="outlined"
                                                        inputProps={{ maxLength: 100 }}
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>
                                                {/* 電話番号 */}
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <CustomControlledInput
                                                        name="editUser.tel"
                                                        control={control}
                                                        label="電話番号（ハイフン無し）"
                                                        placeholder="09012345678"
                                                        inputProps={{ maxLength: 11, pattern: '[0-9]*' }}
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) e.preventDefault();
                                                        }}
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>
                                                {/* メール */}
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <CustomControlledInput
                                                        name="editUser.email"
                                                        control={control}
                                                        label="メールアドレス"
                                                        autoComplete="email"
                                                        placeholder="example@kyuden.co.jp"
                                                        variant="outlined"
                                                        inputProps={{ maxLength: 255 }}
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>
                                                {/* パスワード */}
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <CustomControlledInput
                                                        name="editUser.password"
                                                        control={control}
                                                        label="パスワード"
                                                        type="password"
                                                        autoComplete="password"
                                                        variant="outlined"
                                                        placeholder="パスワードを入力"
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>
                                                {/* パスワード確認 */}
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <CustomControlledInput
                                                        name="editUser.password_confirm"
                                                        control={control}
                                                        label="パスワード(確認)"
                                                        type="password"
                                                        autoComplete="password"
                                                        variant="outlined"
                                                        placeholder="パスワードを入力"
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>
                                                {/* 所属 */}
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <CustomControlledInput
                                                        name="editUser.department"
                                                        control={control}
                                                        label="所属"
                                                        type="select"
                                                        multiple={false}
                                                        options={departmentList.map((d) => ({
                                                            value: d.uuid,
                                                            label: d.name,
                                                        }))}
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>
                                                {/* 権限 */}
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <CustomControlledInput
                                                        name="editUser.role"
                                                        control={control}
                                                        label="権限"
                                                        type="select"
                                                        multiple={false}
                                                        options={roleList.map((r) => ({
                                                            value: r.uuid,
                                                            label: r.name,
                                                        }))}
                                                        disabled={isDisabled}
                                                    />
                                                </Grid>

                                                {/* ボタン類 */}
                                                <Grid
                                                    size={{ xs: 12 }}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    gap={2}
                                                    sx={{ mt: 2 }}
                                                >
                                                    {/* 削除ボタン */}
                                                    <Button
                                                        variant="outlined"
                                                        color="error"
                                                        onClick={() => handleDeleteClick(user)}
                                                        startIcon={<Delete />}
                                                        disabled={isDisabled}
                                                    >
                                                        削除
                                                    </Button>
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        {/* キャンセル */}
                                                        <Button variant="outlined" onClick={handleCancelEdit} disabled={isDisabled}>
                                                            キャンセル
                                                        </Button>
                                                        {/* 保存 */}
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleEditSubmit(
                                                                (data) => { openDialog('save', data.editUser); }
                                                            )}
                                                            sx={{
                                                                backgroundColor: 'rgba(124, 183, 10, 1.0)',
                                                                '&:hover': { backgroundColor: 'rgba(124, 183, 10, 0.8)' }
                                                            }}
                                                            disabled={isDisabled}
                                                        >
                                                            保存
                                                        </Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </form>
                                        {/* ここまで form */}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Grid>
                    </Grid>
                }
            />
        </Grid>
    );
};

export default UserList;